/**
 * @file Defines the {@link isObject} function
 * @author Joe Thompson <joe.thompson@1x2network.com>
 * @version 1.0.30
 */

/**
 * Determine if parameter is an object
 * @returns {boolean} Whether parameter is an object
 */
export function isObject(obj_) {
    return typeof obj_ === 'object' && obj_ !== null && !Array.isArray(obj_)
}